<template>
  <div>
    <div>
        <label v-if="GET_ACCOUNT_DATA.id != 1">{{$t('common.not_permission')}}</label>
        <lte-button v-if="GET_ACCOUNT_DATA.id == 1" style="float:left;background-color:white !important;"
        type="btn btn-default" right_icon="glyphicon glyphicon-log-in" @click="showModalPeriodicTask()">{{$t('batch_job.periodic_login_title')}}</lte-button>
    </div>
    <modal-periodic-task
      ref="onShowModalPeriodicTask"
      @callBackActionPeriodicTask="callBackActionPeriodicTask"
    ></modal-periodic-task>
    <!-- <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import Loading from "vue-loading-overlay";
// import utils from '@/lib/utils';
import LTEButton from "@/components/LTEButton.vue";
import ModalPeriodicTask from "./ModalPeriodicTask"
export default {
  name: "BatchJobPeriodicTask",
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_SNACK_BAR",
    ])
  },
  methods: {
    showModalPeriodicTask: function(){
      this.$refs.onShowModalPeriodicTask.submit();
    },
    callBackActionPeriodicTask: function(){

    },

    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
    ])
  },
  mounted() {
  },

  components: {
    // loading: Loading,
    "lte-button": LTEButton,
    "modal-periodic-task": ModalPeriodicTask
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Project/BatchJobPeriodicTask.vue